import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { Field, useFormikContext } from "formik";
import AddButton from "../buttons/button";
import CloseIcon from "../../assets/icons/close-icon";
import { QRCodeCanvas } from "qrcode.react";
import { imageUploadAction } from "../../redux/actions/general-action";
import { url } from "../../redux/config";
import { useDispatch } from "react-redux";
import successToast from "../helper-components/success-toast";
import { socket } from "../../socket";

export default function BillingUploadPrescription({
  open,
  setOpen,
  isView = false,
}) {
  const dispatch = useDispatch();
  const { setFieldValue, values } = useFormikContext();
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const handleFileChange = (event) => {
    setLoading(true);
    const files = event.target.files?.[0];
    dispatch(imageUploadAction(files, onSuccess, onError));
  };
  const onSuccess = (data) => {
    setLoading(false);
    successToast("Uploaded Successfully");
    setFieldValue("sot_prescription", `${url}/image/${data}`);
    setOpen(false);
  };
  const onError = (data) => {
    setLoading(false);
  };
  const [localIP, setLocalIP] = useState("");

  useEffect(() => {
    const ip = localStorage.getItem("localIP");
    setLocalIP(ip);
  }, []);
  console.log(socket, "fgfgdgdfgdfgdfgdg");

  useEffect(() => {
    if (socket) {
      console.log("socket", socket);
      socket.on("prescriptionUploaded", (data) => {
        setFieldValue("sot_prescription", data?.imageurl);
        setOpen(false);
        successToast("Prescription Uploaded Successfully");
      });
    }
  }, [socket]);
  console.log(values?.sot_prescription, "fgfgdgdfgdfgdfgdg");

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
          // setProductDetails({ item_id: "" });
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[600px] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                {/* Header */}
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div
                    style={{
                      maxHeight: "32px",
                      color: "var(--slide-panel-h-fg)",
                      fontSize: "var(--slide-panel-h-fs)",
                      fontWeight: "var(--slide-panel-h-fw)",
                    }}
                    className="min-w-[75%] "
                  >
                    Upload Prescription
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                      // setProductDetails({ item_id: "" });
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />
                    }
                    text={
                      <span>
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>

                {/* Product Detail Panel */}
                <div
                  style={{
                    height: `calc(100% - 61px)`,
                    minHeight: `calc(100% - 61px)`,
                  }}
                  className="px-4 relative flex flex-col gap-5 items-center justify-center"
                >
                  {isView ? (
                    <img
                      alt="Prescription"
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                      src={values?.sot_prescription}
                    />
                  ) : (
                    <>
                      <div
                        className="w-[17rem] h-[20rem] rounded-md p-2"
                        style={{
                          boxShadow: "var(--qr-code-box-shadow-bg)",
                        }}
                      >
                        <div className="h-[15.5rem] bg-[var(--qr-code-bg)] border-radius flex justify-center items-center">
                          <div className="h-[12rem] w-[80%]">
                            <QRCodeCanvas
                              value={`http://${localIP}:8000/api/order/upload`}
                              size={200}
                              fgColor="black"
                              bgColor="#ffffff"
                            />
                          </div>
                        </div>
                        <div className="w-full flex justify-center mt-[1rem]">
                          <p className="text-[var(--qr-code-fg)] w-[70%]  text-center text-[length:var(--qr-code-fs)] font-[var(--qr-code-fw)]">
                            Scan this QR to upload prescription
                          </p>
                        </div>
                      </div>
                      <AddButton
                        loading={loading}
                        prefixIcon={false}
                        text={"Upload From System (U)"}
                        className="flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-font-size)] 
    font-[var(--primary-button-font-weight)]"
                        type="button"
                        onclkFn={() => fileInputRef.current?.click()} // 👈 Trigger click
                      />

                      <Field name={"sot_prescription"}>
                        {({ field }) => (
                          <input
                            ref={fileInputRef}
                            disabled={false}
                            id={"sot_prescription"}
                            type="file"
                            accept=".png, .jpg, .jpeg"
                            onChange={(event) => {
                              handleFileChange(event);
                              field.onChange(event);
                            }}
                            onBlur={field.onBlur}
                            style={{ display: "none" }}
                          />
                        )}
                      </Field>
                    </>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
